module.exports = __webpack_public_path__ + "static/media/estorno.c7499c72.svg";